import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Id, IResource} from "../../interfaces";
import {Compbaser} from "../compbaser";
import {take} from 'rxjs/operators';
import {StoreSelectorsService} from "../../services";

export type IDialogGetAssetMode =
    'SCENE:ALL' |
    'SCENE:MIME' |
    'SCENE:PLAYER' |
    'SCENE:PLAYER_ASSIGNABLE' |
    'RESOURCE:IMAGES' |
    'RESOURCE:VIDEOS' |
    'RESOURCE:SOUND' |
    'RESOURCE:ALL' |
    'SCENE_RESOURCE:ALL' |
    'SCENE_RESOURCE:PLAYER' |
    'SCENE_RESOURCE_NOLIB' |
    'SCENE_SELECTED' |
    'MUSIC_SELECTED' |
    'RESOURCE_SELECTED' |
    'RESOURCE_CREATED' |
    'SCENE_CREATED' |
    'SCENE:LIBRARY' |
    'RESORUCE:LIBRARY';

export enum EnumMediaType {
    ALL,
    VIDEOS,
    IMAGES,
    SOUND
}

export enum EnumSizeImageType {
    '1024x1024',
    '512x512',
    '256x256'
}


export interface IDialogGetAsset {
    mode: IDialogGetAssetMode;
    mimeType?: string;
    filteredCategories?: Array<string>;
    selected?: Id;
    sourceData?: any;
    selectedType?: IDialogGetAssetMode;
    multiSelect?: boolean;
    includeSelf?: boolean;
    // callBack?: (v) => void;
    // dialogSceneList?: any;
    // dialogResourceList?: IResource[];
}

@Component({
    selector: 'app-dialog-get-asset',
    styleUrls: ['./dialog-get-asset.component.scss'],
    templateUrl: './dialog-get-asset.component.html'
})
export class DialogGetAssetComponent extends Compbaser implements OnInit, AfterViewInit {

    @ViewChild('resourceList', {static: false}) resourceList;
    @ViewChild('sceneList', {static: false}) sceneList;
    // @ViewChildren(MatTabGroup) matTabGroups: QueryList<any>;

    resources: IResource[];
    showImport: boolean;
    m_data: IDialogGetAsset;
    multiSelect = false;
    selectedItems = [];

    constructor(public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: IDialogGetAsset, private storeSelector: StoreSelectorsService) {
        super();
        this.m_data = data;
        this.multiSelect = !!this.m_data.multiSelect;
        this.showImport = this.m_data.mode.indexOf("LIBRARY") > -1 ? false: true;

        this.cod(
            this.storeSelector.getResources().subscribe((r) => {
                this.resources = r;
            })
        );
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        // clear existing selections when open dialog
        setTimeout(() => {
            if (this.resourceList) {
                this.resourceList.selection.clear();
            }
            if (this.sceneList) {
                this.sceneList.selection.clear();
            }
        }, 1000);
    }

    dispatch(selected, selectedType, sourceData) {
        const result: IDialogGetAsset = {
            mode: this.m_data.mode,
            selected,
            sourceData,
            selectedType
        };
        if (this.multiSelect) {
            this.dialogRef.close([result]);
        } else {
            this.dialogRef.close(result);
        }
        // if (this.m_data.callBack)
        //     this.m_data.callBack(result);
    }

    onItemSelected(selected, selectedType: IDialogGetAssetMode) {
        switch (selectedType) {
            case "SCENE_CREATED":
            case "SCENE_SELECTED": {
                if (selectedType === "SCENE_SELECTED" && this.multiSelect) return;

                this.cod(
                    this.storeSelector.getScene(selected)
                        .pipe(take(1))
                        .subscribe((r) => {
                            return this.dispatch(selected, 'SCENE_SELECTED', r);
                        })
                );
                break;
            }
            case "RESOURCE_SELECTED":
            case "RESOURCE_CREATED": {
                if (selectedType === "RESOURCE_SELECTED" && this.multiSelect) return;

                this.cod(
                    this.storeSelector.getResource(selected)
                        .pipe(take(1))
                        .subscribe((r) => {
                            return this.dispatch(selected, selectedType, r);
                        })
                );
                break;
            }
        }
    }

    /**
     * Import multi-resources and multi-scenes, this function is called when only multiSelect = true
     */
    import() {
        // if (!this.resourceList) {
        //     this.dialogRef.close();
        //     return;
        // }
        const resourceIds = this.resourceList?.selection?.selected;
        const sceneIds = this.sceneList?.selection?.selected;
        let selectedResources = [];
        let selectedScenes = [];
        if (resourceIds && resourceIds.length > 0) {
            this.cod(
                this.storeSelector.getResources()
                    .pipe(take(1))
                    .subscribe((resourcesArray) => {
                        selectedResources = resourceIds.map((v) => {
                            return {
                                mode: this.m_data.mode,
                                selected: v,
                                sourceData: resourcesArray.find((s) => s.resource_id === String(v)),
                                selectedType: "RESOURCE_SELECTED"
                            };
                        });
                    })
            );
        }
        if (sceneIds && sceneIds.length > 0) {
            this.cod(
                this.storeSelector.getScenes()
                    .pipe(take(1))
                    .subscribe((sceneArray) => {
                        selectedScenes = sceneIds.map((v) => {
                            return {
                                mode: this.m_data.mode,
                                selected: v,
                                sourceData: sceneArray.find((s) => s.Player.$.id === String(v)),
                                selectedType: "SCENE_SELECTED"
                            };
                        });
                    })
            );
        }
        this.dialogRef.close(selectedResources.concat(selectedScenes));
    }
    
    /**
     * Unused functions for import button
     */
    // ngAfterViewInit() {
    //     setTimeout(() => {
    //         this.initTabs();
    //     });
    // }

    // initTabs() {
    //     this.toggleImportButton();
    //     const tabs: MatTabGroup = this.matTabGroups.first;
    //     if (tabs) {
    //         this.cod(
    //             tabs.focusChange
    //             .subscribe((v) => {
    //                 this.toggleImportButton();
    //             })
    //         );
    //     }
    // }

    // @timeout(30)
    // toggleImportButton() {
    //     this.showImport = false;
    //     if (this.m_data.mode.indexOf('RESOURCE') > -1 || this.m_data.mode.indexOf('SCENE') > -1) {
    //         this.showImport = true;
    //         // if (this.matTabGroups.first) {
    //         //     this.showImport = this.matTabGroups.first?.selectedIndex === 0;
    //         // } else {
    //         //     this.showImport = true;
    //         // }
    //     }
    // }

    // onSelectedTabChange(e) {
    //     console.log(e.tab.textLabel);
    // }
}
